import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Staff } from '../staff.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { TylerMatTableDataSource } from '../../angular-material/extended.class';
import { LoginService } from '../../../shared-modules/login/login.service';

@Component({
    selector: 'app-staff-list-dialog',
    templateUrl: './staff-list-dialog.component.html',
    styleUrls: ['./staff-list-dialog.component.css']
})
export class StaffListDialogComponent implements OnInit {

    // Injected Properties
    staff: Staff[] = [];
    isV10: boolean;
    studentTeam = false;

    // Local Properties
    tableData = new TylerMatTableDataSource();
    private _paginator: MatPaginator;
    @ViewChild(MatPaginator, { static: true }) set paginator(value: MatPaginator) {
        this._paginator = value;
        this.tableData.paginator = value;
    }
    columns = [
        'employee-number',
        'first-name',
        'middle-name',
        'last-name',
        'primary-job',
        'primary-school'
    ];

    // columns = [
    //     'employee-number', 'first-name', 'middle-name', 'last-name', 'primary-job'
    // ];

    // Class Functions
    constructor(
        private loginService: LoginService,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogBox: MatDialogRef<StaffListDialogComponent>
    ) { }

    @ViewChild(MatSort, { static: true }) set sort(value: MatSort) {
        this.tableData.sort = value;
    }

    get sort(): MatSort {
        return this.tableData.sort;
    }

    // Event Functions
    ngOnInit() {
        this.isV10 = this.loginService.LoginSettings.V10;
        if (!this.isV10) {
            this.columns = [];
            // this.columns = ['employee-number', 'staff-name', 'primary-school', 'primary-job', 'staff-status'];
            // this.columns = ['first-name'];

            this.columns = ['staff-name', 'employee-number'];
        }

        if (this.data && this.data.staff) {
            this.staff = this.data.staff;
        }

        if (this.data && this.data.studentTeam) {
            this.studentTeam = this.data.studentTeam;
        }

        if (this.isV10) {
            this.staff.sort((a, b) => {
                if (a.LastName && b.LastName) {
                    const lastNameCompare = a.LastName.localeCompare(b.LastName);
                    if (lastNameCompare != 0) {
                        return lastNameCompare;
                    }
                }
                if (a.FirstName && b.FirstName) {
                    const firstNameCompare = a.FirstName.localeCompare(b.FirstName);
                    if (firstNameCompare != 0) {
                        return firstNameCompare;
                    }
                }
                if (a.MiddleName && b.MiddleName) {
                    return a.MiddleName.localeCompare(b.MiddleName);
                }
                return 0;
            });
        }
        else {
            this.staff.sort((a, b) => {
                const StaffName = a.StaffName ? a.StaffName.localeCompare(b.StaffName):-1;
                if (StaffName != 0) {
                    return StaffName;
                }
            });
        }
        this.tableData.data = this.staff;
    }

    close() {
        // PRE: the close button is clicked
        // POST: closes the dialog box
        this.dialogBox.close();
    }
}
